import publicApiClient, { KlydoPreview } from '../../../api/public';
import useKlydoQuery from '../../../hooks/useKlydoQuery';

const usePublicKlydoQuery = (klydoId: string) => {
  return useKlydoQuery<KlydoPreview>({
    queryKey: ['publicKlydo', klydoId],
    queryFn: () => publicApiClient.getKlydo(klydoId),
    enabled: !!klydoId,
    retry: false,
  });
};

export default usePublicKlydoQuery;
